module.exports = __webpack_public_path__ + "img/5fc8df560d4dab7b3bf958f2ab76b49b.png";